export enum LocalStorageKeyEnum {
    USER = 'USER',
    ROLE = 'ROLE'
}